var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('filter-component'),(_vm.items.length)?_c('main-chart',{staticClass:"mb-4"}):_vm._e(),_c('table-component')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }